// import getKey from 'lodash/get';
import React from 'react';

import Admin from 'hive-admin';
import PageArchiveTable from '../../components/PageArchiveTable';

import {
  ADMIN as FILTERS_ADMIN,
  SELLER as FILTERS_SELLER,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
  SELLER as COLUMNS_SELLER,
  ColumnActions,
} from './columns';

import {
  EDIT as FIELDS_EDIT,
  CREATE as FIELDS_CREATE,
} from './fields';

export default [
  ['ADMIN', {
    path: '/reviews',
  }],
  ['SELLER', {
    path: '/store/reviews',
    loadUrl: '/reviews',
  }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
      FIELDS_FOR_CREATE,
    ] = (
      forRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_EDIT, FIELDS_CREATE]
      : forRole === 'SELLER'
      ? [COLUMNS_SELLER, FILTERS_SELLER, FIELDS_EDIT, []]
      : []
    );
    const isAdmin = forRole === 'ADMIN';
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Reviews',
      // icon: 'star',
      path: config.path,
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', forRole,
          forRole === 'ADMIN'
          ? '/store/reviews'
          : forRole === 'SELLER'
          ? '/reviews'
          : null,
        ],
      ],
      archiveConfig: {
        createButtonSupported: isAdmin,
        createUrl: isAdmin ? '/reviews/admin' : undefined,
        loadUrl: '/reviews',
        // icon: 'star',
        title: 'Reviews',
        label: 'Reviews',
        filters: FILTERS,
        columns: COLUMNS,
        titleColumnPath: 'product.name',
        getColumns: (props) => {
          const { client, reload } = props;
          return PageArchiveTable.defaultProps.getColumns(
            props,
            [
              ...COLUMNS,
              {
                title: 'Approve',
                key: 'actions',
                render: (record) => (
                  <ColumnActions
                    record={record}
                    client={client}
                    reload={reload}
                  />
                ),
              },
            ],
          );
        },
        hidden: [
          [
            'condition.checkViewer',
            'role', '!==', forRole,
          ],
        ],
      },
      singleLoadUrl: '/reviews/:id/?populateCustomer=true',
      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
        headerTitle: 'Review',
      },
      singleEditConfig: {
        actions: [],
      },
      singleCreateConfig: isAdmin ? {
        title: 'Add Review',
        headerTitle: 'Add Review',
        backButtonPaths: [config.path],
        fields: FIELDS_FOR_CREATE,
        createUrl: '/reviews/admin',
      } : undefined,
      fields: FIELDS,
    }])
    .pages);
    return pages;
  },
  [],
);
